var _g, _path, _path2, _path3, _path4, _g2, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgEmptyMappingStateSalesforce(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 36,
    viewBox: "0 0 96 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMappingStateSalesforce_svg__filter0_d_554_51110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.453 8.385H18v15.23h-3.547c-1.415 0-1.928-.147-2.445-.423a2.883 2.883 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.096c0-1.414.147-1.927.424-2.444a2.883 2.883 0 011.199-1.2c.517-.276 1.03-.423 2.445-.423z",
    fill: "#148CFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.385h3.548c1.414 0 1.927.147 2.444.423.517.277.923.683 1.2 1.2.276.517.423 1.03.423 2.444V16H18V8.385z",
    fill: "#4DB1FD"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.615 16v3.548c0 1.414-.147 1.927-.423 2.444a2.884 2.884 0 01-1.2 1.2c-.517.276-1.03.423-2.444.423H18V16h7.615z",
    fill: "#F2FAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36 16h24",
    stroke: "#E1E9F0",
    strokeWidth: 2,
    strokeLinejoin: "round",
    strokeDasharray: "1 3"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#EmptyMappingStateSalesforce_svg__filter1_d_554_51110)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 62,
    width: 32,
    height: 32,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 62.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 7.5,
    stroke: "#E1E9F0"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.49 11.128a3.17 3.17 0 012.283-.969c1.188 0 2.225.655 2.777 1.628.48-.212 1.01-.33 1.57-.33A3.876 3.876 0 0187 15.33a3.876 3.876 0 01-4.645 3.797 2.84 2.84 0 01-2.476 1.437 2.85 2.85 0 01-1.24-.283 3.238 3.238 0 01-2.98 1.95 3.236 3.236 0 01-3.037-2.095 3.003 3.003 0 01-2.12-5.54 3.404 3.404 0 01-.287-1.373c0-1.907 1.565-3.453 3.496-3.453 1.133 0 2.14.533 2.78 1.36",
    fill: "#00A1E0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "EmptyMappingStateSalesforce_svg__filter0_d_554_51110",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_51110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_554_51110",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "EmptyMappingStateSalesforce_svg__filter1_d_554_51110",
    x: 60,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_554_51110"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_554_51110",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyMappingStateSalesforce);
export default ForwardRef;